import { toSentenceCase, withArticle } from './strings';

export const requiredMessage = (name: string) => {
  return `${withArticle(name)} is required.`;
};

export const maxLimitMessage = (name: string, max: number) => {
  return `${toSentenceCase(name)} can be no longer than ${max} characters.`;
};
